import React from "react";

interface CustomLoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const CustomLoader: React.FC<CustomLoaderProps> = ({
  size = "md",
  className = "",
}) => {
  const sizeMap = {
    sm: { width: 16, height: 16 },
    md: { width: 32, height: 32 },
    lg: { width: 48, height: 48 },
  };

  const { width, height } = sizeMap[size];

  return (
    <div className={`inline-block ${className}`}>
      <svg
        viewBox="0 0 50 50"
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id="loaderGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="hsl(151 65% 45%)" />
            <stop offset="100%" stopColor="hsl(151 65% 60%)" />
          </linearGradient>
        </defs>

        {/* Background circle */}
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="#e5e7eb"
          strokeWidth="4"
        />

        {/* Animated circle */}
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="url(#loaderGradient)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="125.6"
          strokeDashoffset="125.6"
          transform="rotate(-90 25 25)"
        >
          <animate
            attributeName="stroke-dashoffset"
            from="125.6"
            to="0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  );
};

export default CustomLoader;
